import {InvoiceTypeEnum} from '@/services/api-clients';

export function invoiceTypeIconFilter(type: InvoiceTypeEnum): string {
  switch (type) {
    case InvoiceTypeEnum.Individual: return 'mdi-account'
    case InvoiceTypeEnum.Business: return 'mdi-domain'
  }
}
